import { useEffect, useState } from 'react';
import { anagrafiche } from '../../api/acquisti';
import type { AnagraficaMago } from '../../api/acquisti';

interface Props {
  valore: string | null;
  onScelto: (codice: string, denominazione: string) => void;
}

/**
 * Ricerca fornitore in Mago per le righe che non hanno offerte a catalogo: una riga
 * scritta a mano dal cantiere non ha un articolo, quindi non ha nessuno che l'abbia
 * quotata, e chi compra deve poter dire da chi la prende.
 */
export function ScegliFornitore({ valore, onScelto }: Props) {
  const [frase, setFrase] = useState('');
  const [risultati, setRisultati] = useState<AnagraficaMago[]>([]);
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);

  useEffect(() => {
    const cercata = frase.trim();
    if (cercata.length < 2) {
      setRisultati([]);
      return;
    }

    // Mezzo secondo di attesa: una ricerca per lettera digitata vuol dire dieci query
    // per scrivere il nome di un fornitore, e le anagrafiche stanno su un altro database.
    let annullato = false;
    const attesa = setTimeout(() => {
      setInCorso(true);
      setErrore(null);
      anagrafiche
        .fornitori(cercata)
        .then((r) => !annullato && setRisultati(r))
        .catch((e: Error) => !annullato && setErrore(e.message))
        .finally(() => !annullato && setInCorso(false));
    }, 500);

    return () => {
      annullato = true;
      clearTimeout(attesa);
    };
  }, [frase]);

  return (
    <div className="scegli-fornitore">
      <input
        type="search"
        placeholder="Cerca fornitore in Mago…"
        value={frase}
        onChange={(e) => setFrase(e.target.value)}
      />
      {inCorso && <span className="attesa">…</span>}
      {errore && <span className="errore">{errore}</span>}

      {risultati.length > 0 && (
        <ul className="risultati">
          {risultati.map((fornitore) => (
            <li key={fornitore.codiceMago}>
              <button
                type="button"
                className={fornitore.codiceMago === valore ? 'on' : ''}
                onClick={() => {
                  onScelto(fornitore.codiceMago, fornitore.denominazione);
                  // Scelto uno, l'elenco degli altri non serve piu' e ruba spazio alla
                  // riga: il nome scelto resta scritto sull'intestazione del riquadro.
                  setFrase('');
                }}
              >
                <strong>{fornitore.denominazione}</strong>
                <span>
                  {fornitore.codiceMago}
                  {fornitore.citta && ` · ${fornitore.citta}`}
                  {!fornitore.attiva && ' · non attivo in Mago'}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}

      {frase.trim().length >= 2 && !inCorso && risultati.length === 0 && !errore && (
        <p className="vuoto">Nessun fornitore con questo nome.</p>
      )}
    </div>
  );
}
